import React, { Fragment, useRef, useState } from 'react';
import Topbar from './Topbar';
import { Helmet } from 'react-helmet';
import { Dialog, Transition } from '@headlessui/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getPathForInstantSupport } from '../../utils/helper';
import instantSupportDialogIcon from '../../assets/images/instantSupportDialogIcon.svg';
import infoIcon from '../../assets/images/info-circle.svg';
import AddCompanyUserValidation from '../../validation/AddCompanyUserValidation';
import { API_BASE_URL } from '../../core/env.configs';
import { getJWTToken, errorToast } from '../../utils/helper';
import { CompanyApi } from '../../api/companyApi';
import instantSupportTick from '../../assets/images/instant-support-tickmark.svg';
import { is } from 'date-fns/locale';
import Loader from '../../component/common/Loader';

const InstantSupportCheckoutPage = () => {
  const [open, setOpen] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const [loader, setloader] = useState(false);
  const cancelButtonRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { userType, companyId, companyName } = JSON.parse(localStorage.getItem('userData'));

  const {
    planName,
    planTitle,
    isAnnualPlan,
    employeeCount,
    planRequirements,
    totalAddOnPrice,
    planPrice,
    addOns
  } = location.state || {};
  // console.log('location.state', location.state);
  //const { planName } = location.state || {};

  const totalPrice = planPrice * employeeCount;

  // const planIDsToPlanName = {
  //   plan456: 'Telephonic EAP', // Telephonic EAP
  //   plan457: 'Face to Face & Video Services EAP', // Face to Face & Video Services EAP
  //   plan458: 'Shoorah RISE Plan' // Shoorah RISE Plan
  // };

  const planNamesToPlanIDs = {
    telephonic: 0,
    face: 1,
    rise: 2
  };

  const [selected, setSelected] = useState(false);

  const toggleSelection = () => {
    setSelected((prev) => !prev); // Toggle selection
  };

  const handlePayment = (typeOfPayment) => {
    setloader(true);

    //const url = `${API_BASE_URL}company/v1/instantSupport/booking-instant-plan`;
    // instantSupport/booking-instant-plan

    const payload = {
      planId: planNamesToPlanIDs[planName],
      numberOfEmployees: employeeCount,
      billingType: isAnnualPlan ? 'yearly' : 'monthly',
      type: typeOfPayment,
      autoRenew: selected
    };

    console.log('Payload', payload);

    try {
      CompanyApi.getInstantSupportStripLink(payload)
        .then(async (response) => {
          console.log('response', response);
          if (response) {
            if (response?.code === 400) {
              console.log('STRIPE/PAY ON INVOICE API RESPONSE', response);
              errorToast(response?.message);
            } else {
              const stripeLink = await response?.data?.data?.paymentLink;
              console.log('sending the user to this stripe link', stripeLink);
              if (stripeLink) {
                window.open(stripeLink, '_blank');
              }
              setOpen(true);
            }
          }
        })
        .catch((error) => {
          console.error('Error making stripe/pay on invoice API call:', error);
        })
        .finally(() => {
          //setOpen(true);
          setloader(false);
        });
    } catch (error) {
      console.error('Error making stripe/pay on invoice API call:', error);
      alert('There was an error processing your payment. Please try again.');
    }
  };

  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>B2B | Get Support</title>
      </Helmet>
      {loader ? <Loader /> : null}
      <Topbar title={'Instant Support (EAP)'} infoBtn={false} />

      <div className="flex flex-col w-full max-w-4xl mt-12 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8 shadow-md">
        <div className="flex flex-col sm:flex-row justify-between mb-2 items-start sm:items-center">
          <p className="text-lg sm:text-xl font-medium  text-gray-900 dark:text-white">
            Select an add-on plan
          </p>
          <a
            href="mailto:info@shoorah.io"
            className="btn-primary btn-sm sm:mt-0 w-auto h-auto"
          >
            Speak to Sales?
          </a>
        </div>

        {(planNamesToPlanIDs[planName] !== 2 || employeeCount <= 20) && (
          <div className="flex flex-col sm:flex-row items-start gap-3 p-3 mt-2 border w-full sm:w-5/6 border-gray-300 dark:border-gray-600 rounded-lg bg-[#F1F1F1] dark:bg-gray-600">
            <img
              src={infoIcon}
              alt="Instant Support (EAP) info"
              className="w-4 h-4 sm:mt-1 sm:w-4 sm:h-4"
            />
            <div className="flex flex-col">
              {planNamesToPlanIDs[planName] !== 2 && (
                <p className="text-gray-700 dark:text-gray-300 text-xs sm:text-sm">
                  This payment is an add-on and does not affect your existing Shoorah subscription.
                  Regular subscription payments, such as monthly charges, will continue as usual.
                </p>
              )}

              {employeeCount <= 20 && (
                <p className="text-gray-700 dark:text-gray-300 text-xs sm:text-sm mt-2">
                  For seats below 20, there will be a £200 processing fee.
                </p>
              )}
            </div>
          </div>
        )}

        <div className="w-full sm:w-3/4 lg:w-full mr-auto mt-8 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
          <div className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-100 dark:bg-gray-800 border-b border-gray-300 dark:border-shoorah-darkBorder flex justify-between items-center">
            <div className="text-gray-700 dark:text-gray-300 font-medium text-xs sm:text-sm">
              How many employees do you wish to add to this plan?
            </div>
            <div className="w-12 h-6 flex items-center justify-center border border-gray-300 rounded-md bg-white dark:bg-shoorah-darkGray text-black dark:text-white text-sm sm:w-10 sm:h-5 sm:text-sm md:w-14 md:h-7 md:text-base">
              {employeeCount}
            </div>
          </div>

          <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
            <div>
              <label
                key={'one'}
                className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                onClick={() => {}}
              >
                <div className="flex items-center w-full sm:w-auto">
                  <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                    {planTitle}
                  </span>
                </div>
                <div className="flex-1 text-left sm:text-right">
                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                    <span className="text-lg sm:text-2xl ">£</span>
                    {planPrice} +VAT{' '}
                    <span className="font-normal">{isAnnualPlan ? '/yr' : '/month'}</span>
                  </div>
                </div>
              </label>

              <div className="h-[0.5px] mx-5 bg-gray-200"></div>

              {/* Requirements Dropdown */}
              <div className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 cursor-pointer">
                <span className="text-gray-900 dark:text-gray-300 font-medium ml-2 sm:ml-3">
                  Requirements
                </span>
              </div>

              <div className="sm:w-1/2 mt-1 mb-2 mx-4 sm:mx-8">
                {planRequirements &&
                  planRequirements.map((text, index) => (
                    <div key={index} className="flex items-start my-3 text-xs sm:text-sm">
                      <img
                        src={instantSupportTick}
                        alt="DropdownIcon"
                        className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                      />
                      <span className="text-[#606060] dark:text-gray-300">{text}</span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>

        {/* <div className="border mt-6"></div> */}

        <div className="w-full sm:w-1/2 mr-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
          <div
            className="px-4 sm:px-6 py-4 bg-white dark:bg-shoorah-darkBgTabColor  border-gray-300 dark:border-shoorah-darkBorder flex justify-between items-center
          
          "
          >
            {/* border-b */}
            <div className="text-gray-700 dark:text-gray-300 font-medium text-base">
              Total Payment:
            </div>
            <span className="text-base text-gray-900 font-bold  dark:text-gray-400">
              <span className="text-base sm:text-lg">£</span>
              {totalPrice.toFixed(2)}{' '}
            </span>
          </div>

          {/* <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
            <label className="flex items-center gap-3 px-4 sm:px-6 py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
              <div className="flex flex-row">
                <input
                  type="radio"
                  name="final-checkout"
                  checked={selected} // Control selection
                  readOnly // Prevent default behavior
                  className="form-radio text-shoorah-primary"
                  onClick={() => {
                    toggleSelection();
                  }}
                />
                <span className="mx-1 text-sm font-medium text-gray-900 dark:text-white">
                  Auto Renew your plan
                </span>
              </div>
            </label>
          </div> */}
        </div>

        <div className="flex flex-wrap items-center gap-2 sm:flex-nowrap">
          {/* <button
            onClick={() => {
              handlePayment(3);
              // setOpen(true);
            }}
            disabled={isLoading}
            className="btn-primary"
          >
            {isLoading ? 'Processing...' : `Pay ${totalPrice ? '£' + totalPrice : ''}`}
          </button> */}

          <button
            onClick={() => {
              // Invoice API Call to be done here and the show "Your payment is currently under review"
              console.log('Pay on Invoice');
              handlePayment(2);
              // setOpen(true);
            }}
            className="w-full sm:w-[160px] p-2 mt-8 text-sm font-normal rounded-full border border-shoorah-lightBlack dark:border-shoorah-darkBg 
              dark:text-shoorah-darkBg text-shoorah-lightBlack bg-transparent 
               disabled:opacity-50 transition-all "
          >
            Pay on Invoice
          </button>
        </div>
      </div>

      {/* Dialog box for success message */}
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-50" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 dark:bg-black !bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor text-left shadow-xl transition-all sm:my-8 sm:w-[calc(100%-2rem] md:max-w-5xl">
                  <div className="bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder p-8 md:py-16 md:px-[120px] border-[1.5px] border-shoorah-borderGray flex flex-col items-center justify-center text-center">
                    <div className="mt-6 md:mt-0 sm:ml-4 mb-8 flex flex-col items-center">
                      <Dialog.Title
                        as="h3"
                        className="md:text-[32px] text-3xl font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg"
                      >
                        <img
                          src={instantSupportDialogIcon}
                          alt="DropdownIcon"
                          className="dark:invert mx-auto"
                        />
                      </Dialog.Title>
                    </div>
                    <div>
                      <p className="text-lg text-gray-700 dark:text-gray-300">
                        Your payment is currently under review. This process typically <br /> takes
                        24-48 hours. We'll notify you as soon as it's completed.
                      </p>
                      <button
                        className="w-[173px] h-[40px] bg-[#1F1F1F] text-white text-lg font-normal rounded-full border border-gray-300 cursor-pointer shadow-sm flex items-center justify-center mx-auto mt-6"
                        onClick={() => {
                          setOpen(false);
                          // Force navigation after a short delay to ensure dialog closing completes
                          setTimeout(() => {
                            navigate(getPathForInstantSupport('/instant-support'));
                          }, 100);
                        }}
                      >
                        Got It
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default InstantSupportCheckoutPage;
